import React from 'react'
// import * as React from 'react';
import Slide from '@mui/material/Slide';
import "./Permissons.css";
import { useState, useEffect } from 'react';
import Modelform from '../modalForm/createRoleTemplate';
import Createusermodal from '../modalForm/CreateUserTemplate';
import { useDispatch } from "react-redux";
import { getRole, deleteRoleById, createRole, updateRoleById ,getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import { getPermission } from "./../../../../services/global_redux/globale_actions/Permission.action"
import { getAllUnits } from "./../../../../services/global_redux/globale_actions/Unit.action"
import { createUser, getUser, updateUserById, deleteUserById, reSentMail } from "./../../../../services/global_redux/globale_actions/Login.action"
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Select from 'react-select';
import { json } from 'react-router-dom';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function Permissions({ showSnackbar, setLoading }) {
  const [open, setOpen] = React.useState(false);
  const [createopen, setcreateOpen] = React.useState(false);
  const [roleData, setRoleData] = React.useState([])
  const [userData, setUserData] = React.useState([])
  const [permissionData, setPermissionData] = React.useState([])
  const dispatch = useDispatch();
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [openroledeletealert, setopenroledeletealert] = useState(false);
  const [openUserdeletealert, setopenUserdeletealert] = useState(false);
  const [deleteroleid, setroledeleteid] = useState(null);
  const [deleteuserid, setuserdeleteid] = useState(null);
  const [roles, setroles] = useState(null);
  const [clientAndUnit, setClientAndUnit] = useState(null);
  const [userdeleteiddata, setuserdeleteiddata] = useState(null);
  const [roleName, setRoleName] = useState('');
  const [sendmail, setsendmail] = useState();
  const createmodalhandleOpen = () => setcreateOpen(true);
  const createmodalhandleClose = () => setcreateOpen(false);
  const [formValues, setFormValues] = useState({
    role_name: '',
    base_role: '',
    role_description: '',
    permissions: [],
    role_status: ''
  });
  const [selectedSections, setSelectedSections] = useState({});
  const [selectedModules, setSelectedModules] = useState({});
  const [selectedSubModules, setSelectedSubModules] = useState({});
  const [crudPermissions, setCrudPermissions] = useState({});

  const [selectedClients, setSelectedClients] = useState({});
  const [selectedUnits, setSelectedUnits] = useState({});
  const [checkAllClients, setCheckAllClients] = useState(false);
  const [checkAllUnits, setCheckAllUnits] = useState(false);
  const uniqueSections = [...new Set(permissionData.map((item) => item.section))];
  const handleCheckbox = (setter, key) => {
    setter((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const [clientSearch, setClientSearch] = useState('');
  const handleCrudToggle = (key, type) => {
    setCrudPermissions((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [type]: !prev[key]?.[type],
      },
    }));
  };
  const isCrudEnabled = (action) =>
  action === "yes" ||
  action === "Yes" ||
  (typeof action === "object" && action !== null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = [];

    permissionData.forEach((item) => {
      const { section, module, action, sub_module } = item;

      if (!selectedSections[section] || !selectedModules[module]) return;

      const entry = { section, module, action };
      if (sub_module.length > 0) {
        const subEntries = [];
        sub_module.forEach((sub) => {
          const key = `${module}-${sub.name}`;
          if (selectedSubModules[key]) {
            const subEntry = {
              name: sub.name,
            //   action: sub.action,
              action: {
                create: crudPermissions[key]?.create || false,
                edit: crudPermissions[key]?.edit || false,
                delete: crudPermissions[key]?.delete || false,
              },
            };
            subEntries.push(subEntry);
          }
        });
        if (subEntries.length > 0) entry.sub_module = subEntries;
      } else {
        const key = `${module}`;
        entry.action = {
          create: crudPermissions[key]?.create || false,
          edit: crudPermissions[key]?.edit || false,
          delete: crudPermissions[key]?.delete || false,
        };
      }

      result.push(entry);
    });
    try {
        const getRoleDetails = roles.find((item) => item.id == roleName);
        const getPermittedData = {
            permissions:result,
            role_name:getRoleDetails.role_name
        }
        const response = await dispatch(updateRoleById(getRoleDetails.id,getPermittedData));
        setRoleData(response.data);
        setLoading(false);
        showSnackbar(response.message);
        handleFetchStates()
        setSelectedSections({});
        setSelectedModules({});
        setSelectedSubModules({});
        setCrudPermissions({});
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
  };
  const modalhandleOpen = () => setOpen(true);
  const modalhandleClose = () => setOpen(false);
  const modalhandleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleFetchStates = async () => {
    try {
      const response = await dispatch(getRole());
      setRoleData(response.data);
      setroles(response.data)
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
    handleFetchStates();
  }, [dispatch]);
  function transformPermissionsForForm(rolePermissions = []) {
    const sections = {};
    const modules = {};
    const subModules = {};
    const crud = {};

    rolePermissions.forEach((perm) => {
      const sectionKey = perm?.section;
      const moduleKey = perm?.module;

      if (!sectionKey || !moduleKey) return;

      sections[sectionKey] = true;
      modules[moduleKey] = true;

      const hasSubModules = Array.isArray(perm.sub_module) && perm.sub_module.length > 0;

      if (hasSubModules) {
        perm.sub_module.forEach((sub) => {
          const subKey = `${moduleKey}-${sub.name}`;
          subModules[subKey] = true;

                    const actions =
            typeof sub.action === "object" && sub.action !== null
                ? sub.action
                : {};

            crud[subKey] = {
            create: !!actions.create,
            edit: !!actions.edit,
            delete: !!actions.delete,
            };
        });
      } else {
        // Handle module-level actions safely
        const moduleActions =
            typeof perm.action === "object" && perm.action !== null
                ? perm.action
                : {};

            crud[moduleKey] = {
            create: !!moduleActions.create,
            edit: !!moduleActions.edit,
            delete: !!moduleActions.delete,
            };

      }
    });

    return { sections, modules, subModules, crud };
  }

  const handleRoleSelect = (roleData) => {
    const permissionList = roleData?.permissions || [];
    const permissionData = transformPermissionsForForm(permissionList);

    setSelectedSections(permissionData.sections);
    setSelectedModules(permissionData.modules);
    setSelectedSubModules(permissionData.subModules);
    setCrudPermissions(permissionData.crud);
  };
  const deleteRole = async () => {
    setLoading(true);
    setopenroledeletealert(false);
    try {
      const response = await dispatch(deleteRoleById(deleteroleid));
      setRoleData(response.data);
      setLoading(false);
      showSnackbar(response.message);
      handleFetchStates()
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  const modalhandleSubmit = (e) => {
    e.preventDefault();
    create_Role(formValues);
    modalhandleClose();
  };
  const create_Role = async (formValues) => {
    setLoading(true);
    try {
      const response = await dispatch(createRole(formValues));
      setRoleData(response.data);
      setLoading(false);
      if (response.success === true) {
        showSnackbar(response.message, "success");
      } else {
        showSnackbar(response.message, "warning");
      }
      handleFetchStates()
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  const company_code_new = JSON.parse(sessionStorage.getItem('user'));
  const [createformValues, setcreateFormValues] = useState({
    user_id: '',
    company_code: company_code_new?.company_code,
    user_name: '',
    user_email: '',
    role_name: '',
    mail_sent: ''
  });
  const createmodalhandleChange = (e) => {
    const { name, value } = e.target;
    setcreateFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const createmodalhandleSubmit = async (data) => {
    // e.preventDefault();
    console.log(data.client_and_unit);
    const send_data_to_create = {
        'client_and_unit':JSON.stringify(data.client_and_unit),
        ...createformValues
    }

    setLoading(false);
    createmodalhandleClose();
    try {
      const response = await dispatch(createUser(send_data_to_create));
      setRoleData(response.data);
      setLoading(false);
      FetchUser()
      if (response.success == true) {
        showSnackbar(response.message, "success");
      } else {
        showSnackbar(response.message, "warning");
      }
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', options);
  }
  const fetchPermission = async () => {
    try {
      const response = await dispatch(getPermission());
      setPermissionData(response.data[0].permissions);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    fetchPermission();
  }, [dispatch]);
  const FetchUser = async () => {
    try {
      const company_code_new = JSON.parse(sessionStorage.getItem('user'));
      const response = await dispatch(getUser(company_code_new.company_code));
      setUserData(response.data);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    FetchUser();
  }, [dispatch]);
  const handleEditClick = (id) => {
    const item = userData.find((d) => d.auth_id === id);
    setEditableRow(id);
    setEditedValues({ ...item });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedValues({
      ...editedValues,
      [name]: value,
    });
  };
  const handleSaveClick = async (e) => {
    setLoading(true);
    try {
      const response = await dispatch(
        updateUserById(editedValues.auth_id, editedValues)
      );
      if (response.message) {
        showSnackbar(response.message, "success");
        setLoading(false);
        FetchUser()
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };
  const handleCancelClick = () => {
    setEditableRow(null);
    setEditedValues({});
  };
  const handleDeleteClick = async () => {
    setLoading(true);
    setopenUserdeletealert(false);
    try {
      const response = await dispatch(deleteUserById(deleteuserid));
      if (response.success) {
        showSnackbar(response.message, "success");
        setLoading(false);
        FetchUser()
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };
  const handleRoleChange = (e) => {
    setRoleName(e.target.value);
    const getRoleDetail = roles.find((item) => item.id == e.target.value);
    handleRoleSelect(getRoleDetail);
  };
  const handledeleteRoleClickOpenalert = (id) => {
    setopenroledeletealert(true);
    setroledeleteid(id)
  };
  const handledeleteuserClickOpenalert = (id) => {
    setopenUserdeletealert(true);
    setuserdeleteid(id)
  };
  const handleroledeleteClosealert = () => {
    setopenroledeletealert(false);
  };
  const handleuserdeleteClosealert = () => {
    setopenUserdeletealert(false);

  }
  function sendsermail(id) {
    setLoading(true);
    setsendmail({
      auth_id: id
    });
    handleSentMail();
  }
  const handleSentMail = async () => {
    try {
      const response = await dispatch(
        reSentMail(sendmail)
      );
      if (response.success == true) {
        showSnackbar(response.message, "success");
        setLoading(false);
        FetchUser()
      }else if(response.success == false){
        showSnackbar(response.message, "error");
        setLoading(false);
        FetchUser()
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };

  const handleFetchClientAndUnit = async () => {
    try {
      const response = await dispatch(getAllUnits());
      const client_and_unit = JSON.stringify(response.data.client_and_unit);
      setClientAndUnit(response.data.client_and_unit);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    handleFetchClientAndUnit();
  }, [dispatch]);
  const handleClientCheck = (clientId, isChecked) => {
    const updatedClients = { ...selectedClients, [clientId]: isChecked };

    const updatedUnits = { ...selectedUnits };
    const clientUnits = clientAndUnit.find(c => c.client_id === clientId)?.unit_id || [];

    if (!isChecked) {
        // Only uncheck units if client is being unchecked
        clientUnits.forEach(unit => {
          updatedUnits[unit] = false;
        });
      }


    setSelectedClients(updatedClients);
    setSelectedUnits(updatedUnits);
  };

  const handleUnitCheck = (unitId, isChecked) => {
    setSelectedUnits(prev => ({ ...prev, [unitId]: isChecked }));
  };

  const handleCheckAllClients = (isChecked) => {
    const updatedClients = {};
    const updatedUnits = {};

    clientAndUnit.forEach(client => {
      updatedClients[client.client_id] = isChecked;
      if (!isChecked) {
        client.unit_id.forEach(unit => {
          updatedUnits[unit] = false;
        });
        document.getElementById('checkAllUnits').checked = false;
      }
    });

    setSelectedClients(updatedClients);
    setSelectedUnits(updatedUnits);
    setCheckAllClients(isChecked);
  };

    const handleCheckAllUnits = (isChecked) => {
        const updatedUnits = { ...selectedUnits };

        clientAndUnit.forEach(client => {
        if (selectedClients[client.client_id]) {
            client.unit_id.forEach(unit => {
            updatedUnits[unit] = isChecked;
            });
        }
        });

        setSelectedUnits(updatedUnits);
        setCheckAllUnits(isChecked);
    };
    const getSelectedData = () => {
        const selectedData = [];

        clientAndUnit.forEach(client => {
        if (selectedClients[client.client_id]) {
            const selectedUnitIds = client.unit_id.filter(unit => selectedUnits[unit]);

            selectedData.push({
            client_id: client.client_id,
            unit_id: selectedUnitIds
            });
        }
        });

        return selectedData;
    };
     const selectedClienthandleSubmit = async (e) => {
        e.preventDefault();
        const data = getSelectedData();
        const send_data = {
            'client_and_unit':data
        }

        try {
            const response = await dispatch(updateUserById(userdeleteiddata,send_data));
            if (response.success == true) {
                showSnackbar(response.message, "success");
                setLoading(false);
                FetchUser()
                handleFetchClientAndUnit();
            }else if(response.success == false){
                showSnackbar(response.message, "error");
                setLoading(false);
                FetchUser()
            } else {
                showSnackbar(response.message, "warning");
                setLoading(false);
            }
        } catch (err) {
            console.error("Failed to fetch states:", err);
        }

    };

    const handleRoleChangeuserID = (e) => {
        const userSelectedID = e.target.value
        setuserdeleteiddata(userSelectedID);
        const updatedClients = {};
        const updatedUnits = {};
        if (userSelectedID) {
            const selectedUser = userData.find((item) => item.auth_id == userSelectedID);
            const assigned = typeof selectedUser.client_and_unit === 'string' ? JSON.parse(selectedUser.client_and_unit) : selectedUser.client_and_unit;

            if (Array.isArray(assigned)) {

                assigned.forEach((entry) => {
                  const client = clientAndUnit.find(c => c.client_id === entry.client_id);

                  if (client) {
                    updatedClients[entry.client_id] = true;

                    entry.unit_id.forEach((unit) => {
                      if (client.unit_id.includes(unit)) {
                        updatedUnits[unit] = true;
                      }
                    });
                  }
                });

              } else {
              }
        }else{
            clientAndUnit.forEach(client => {
                updatedClients[client.client_id] = false;
                  client.unit_id.forEach(unit => {
                    updatedUnits[unit] = false;
                  });
              });
        }
          setSelectedClients(updatedClients);
          setSelectedUnits(updatedUnits);

    };
    const options = userData?.map((item) => ({
        value: item.auth_id,
        label: item.user_id,
      }));

      const handleSelectChange = (selectedOption) => {
        const fakeEvent = {
          target: {
            name: 'emp_role',
            value: selectedOption ? selectedOption.value : "",
          },
        };
        handleRoleChangeuserID(fakeEvent);
      };
  return (
    <div className="contaner-fluid container-fluid-color m-0">
      <div className="col-md-12 p-3">
        <div className="card ">
          <div className="card-header  card-header-color py-0">
            <div className="col-md-12">
              <div className="row client-form-header ">
                <div className="col-md-6 pt-2">
                  <h6>User Credentials</h6>
                </div>
                <div className="col-md-6">
                  <a href="/dashboard" className='text-white'><i className="bi bi-x float-end cancel-icon"></i></a>

                </div>
              </div>
            </div>
          </div>
          <div className="card-body bg-light">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row  justify-content-between">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6>Add Role For User</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 pb-1">
                              <button className='btn btn-success btn-sm float-end ' onClick={createmodalhandleOpen}>Create User</button>
                              <Createusermodal
                                open={createopen}
                                handleClose={createmodalhandleClose}
                                formValues={createformValues}
                                handleChange={createmodalhandleChange}
                                handleSubmit={createmodalhandleSubmit}
                                setcreateFormValues={setcreateFormValues}
                                roles={roles}
                                clientAndUnit = {clientAndUnit}
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="table-responsive permissonTableSize1">
                          <table className="table table-bordered permission-table ">
                            <thead className="sticky-top bg-dark">
                                <tr className='text-center'>
                                    <th>SL no</th>
                                    <th>User ID</th>
                                    <th>Company Code</th>
                                    <th>Mail ID</th>
                                    <th>Role Name</th>
                                    <th>Mail Notification</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                              {userData ? (<>
                                {userData.map((item, index) => (
                                  <tr key={item.auth_id}>
                                    <td>
                                      {index + 1}
                                    </td>
                                    <td>
                                      {item.user_id}
                                    </td>
                                    <td>
                                      {editableRow === item.company_code ? (
                                        <input
                                          type="text"
                                          value={editedValues.company_code}
                                          name="company_code"
                                          onChange={handleInputChange}
                                        />
                                      ) : (
                                        item.company_code
                                      )}
                                    </td>                                  
                                    <td>
                                      {editableRow === item.auth_id ? (
                                        <input
                                          type="text"
                                          value={editedValues.user_email}
                                          name="user_email"
                                          onChange={handleInputChange}
                                        />
                                      ) : (
                                        item.user_email
                                      )}
                                    </td>

                                    <td>
                                      {editableRow === item.auth_id ? (
                                        <select
                                          value={editedValues.role_name}
                                          name="role_name"
                                          onChange={handleInputChange}
                                        >
                                          <option value="">--select--</option>
                                          {roleData.map((item) => (
                                            <option value={item.role_name}>{item.role_name}</option>
                                          ))}
                                        </select>
                                      ) : (
                                        item.role_name
                                      )}
                                    </td>
                                    <td>
                                      {item.mail_sent == 0 ? (<>
                                        <button className="btn btn-success" onClick={() => sendsermail(item.auth_id)} >Send</button>
                                      </>) : (<>
                                        <button className="btn btn-info" onClick={() => sendsermail(item.auth_id)} >Resend</button>
                                      </>)}
                                    </td>
                                    <td className="text-center">
                                      {editableRow === item.auth_id ? (
                                        <div className="d-flex justify-content-between">
                                          <span
                                            onClick={() => handleSaveClick(item.auth_id)}
                                            className="cursor-pointer p-0 m-2"
                                          >
                                            <i className="bi bi-floppy2-fill text-success auction-btn"></i>

                                          </span>
                                          <span
                                            onClick={handleCancelClick}
                                            className="cursor-pointer p-0  m-2"
                                          >
                                            <i className="bi bi-x-circle text-info auction-btn"></i>
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="d-flex justify-content-between">
                                          <span
                                            onClick={() => handleEditClick(item.auth_id)}
                                            className="cursor-pointer p-0  m-2"
                                          >
                                            <i className="bi bi-pencil-square text-info auction-btn"></i>
                                          </span>
                                          <span
                                            onClick={() =>
                                              handledeleteuserClickOpenalert(item.auth_id)
                                            }
                                            className="cursor-pointer p-0  m-2"
                                          >
                                            <i className="bi bi-trash3-fill text-danger auction-btn"></i>
                                          </span>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </>) : (<tr>no data found</tr>)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                            <form onSubmit={selectedClienthandleSubmit}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row justify-content-between align-items-center mb-3">
                                            <div className=" col-md-5">
                                                <h6 className="mb-3 mb-md-0">Client and unit for user</h6>
                                            </div>
                                            <div className=" col-md-7">
                                                <div className="row align-items-center">
                                                <label htmlFor="emp_role" className="col-md-4 col-form-label fw-bold">
                                                    User ID <span className="text-danger">*</span> :
                                                </label>
                                                <div className="col-md-8">
                                                    {/* <select
                                                    id="emp_role_for_client_unit"
                                                    name="emp_role"
                                                    className="form-select text-center"
                                                    onChange={handleRoleChangeuserID}
                                                    required
                                                    >
                                                    <option value="">-- Select --</option>
                                                    {userData?.map((item) => (
                                                        <option key={item.auth_id} value={item.auth_id}>
                                                        {item.user_id}
                                                        </option>
                                                    ))}
                                                    </select> */}
                                                    <Select
                                                        id="emp_role_for_client_unit"
                                                        name="emp_role"
                                                        className="text-center"
                                                        options={options}
                                                        onChange={handleSelectChange}
                                                        placeholder="-- Select --"
                                                        isClearable
                                                        isSearchable
                                                        />
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                            <TextField
                                            label="Search Client"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={clientSearch}
                                            onChange={(e) => setClientSearch(e.target.value)}
                                            sx={{ mb: 2 }}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive permissonTableSize1">
                                        <table className="table table-bordered align-middle  permission-table">

                                        <thead className="">
                                        <tr>
                                            <th>
                                                <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="checkAllClients"
                                                    checked={checkAllClients}
                                                    onChange={(e) => handleCheckAllClients(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="checkAllClients">
                                                    Clients
                                                </label>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="checkAllUnits"
                                                    onChange={handleCheckAllUnits}
                                                    disabled={!Object.values(selectedClients).some(Boolean)}
                                                />
                                                <label className="form-check-label" htmlFor="checkAllUnits">
                                                    Units
                                                </label>
                                                </div>
                                            </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* {clientAndUnit && <>
                                                {clientAndUnit.map((item, clientIndex) => ( */}
                                                {clientAndUnit && clientAndUnit
                                            .filter(item => item.client_name.toLowerCase().includes(clientSearch.toLowerCase()))
                                            .map((item, clientIndex) => (
                                            <tr key={clientIndex}>
                                            <td>
                                                <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`client-${clientIndex}`}
                                                    checked={selectedClients[item.client_id] || false}
                                                    onChange={(e) =>
                                                    handleClientCheck(item.client_id, e.target.checked)
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`client-${clientIndex}`}
                                                >
                                                    {item.client_name}
                                                    {/* {'('}{item.client_id}{')'} */}
                                                </label>
                                                </div>
                                            </td>
                                            <td>
                                                {item.unit_id.map((unit, unitIndex) => (
                                                <>
                                                    <div className="form-check form-check-inline" key={unitIndex}>
                                                    <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`unit-${clientIndex}-${unitIndex}`}
                                                    disabled={!selectedClients[item.client_id]}
                                                    checked={selectedUnits[unit] || false}
                                                    onChange={(e) => handleUnitCheck(unit, e.target.checked)}
                                                    />
                                                    <label
                                                    className="form-check-label"
                                                    htmlFor={`unit-${clientIndex}-${unitIndex}`}
                                                    >
                                                    {item.unit_names[unitIndex]}
                                                    {/* {'('}{unit}{')'} */}
                                                    </label>
                                                </div>
                                                <br/>
                                                </>
                                                ))}
                                            </td>
                                            </tr>
                                            ))}
                                            {/* </> */}
                                            {/* } */}

                                        </tbody>
                                        </table>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                        <button type="submit" className="btn btn-success mt-3 float-end">
                                        Submit
                                    </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row  justify-content-between ">
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <h6>Add Role</h6>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 pb-1">
                                  <button className='btn btn-success btn-sm float-end ' onClick={modalhandleOpen}>Create Role</button>
                                  <Modelform
                                    open={open}
                                    handleClose={modalhandleClose}
                                    formValues={formValues}
                                    handleChange={modalhandleChange}
                                    handleSubmit={modalhandleSubmit}
                                  />
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="table-responsive permissonTableSize1">
                              <table className="table table-bordered permission-table">
                                <thead className='sticky-top'>
                                  <tr className='text-center'>
                                    <th>SL NO</th>
                                    <th>Role Name</th>
                                    <th>Base Role</th>
                                    <th>Role Description</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {roleData ? (<>
                                    {roleData.map((item, index) => (
                                      <tr key={item.auth_id || index}>
                                        <td className='text-center'>
                                          {index + 1}
                                        </td>
                                        <td className="text-center">
                                          {item.role_name}
                                        </td>
                                        <td className='text-center'>
                                          {item.base_role}
                                        </td>
                                        <td className="text-center">
                                          {item.role_description}
                                        </td>
                                        <td className="text-center">
                                          {item.role_status}
                                        </td>
                                        <td className='text-center'>
                                          <span
                                            onClick={() =>
                                              // deleteRole(item.id)
                                              handledeleteRoleClickOpenalert(item.id)
                                            }
                                            className="btn p-0"
                                          >
                                            <i className="bi bi-trash3-fill text-danger auction-btn"></i>
                                          </span>
                                        </td>

                                      </tr>
                                    ))}
                                  </>) : (<></>)
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                    <form onSubmit={handleSubmit} >
                    <div className="card">
                        <div className="card-body">
                            <div className="row justify-content-between align-items-center mb-3">
                                <div className=" col-md-5">
                                    <h6 className="mb-3 mb-md-0">Add Permissions To Roles</h6>
                                </div>
                                <div className=" col-md-7">
                                    <div className="row align-items-center">
                                    <label htmlFor="emp_role" className="col-md-4 col-form-label fw-bold">
                                        Role Name <span className="text-danger">*</span> :
                                    </label>
                                    <div className="col-md-8">
                                        <select
                                        id="emp_role"
                                        name="emp_role"
                                        className="form-select text-center"
                                        onChange={handleRoleChange}
                                        required
                                        >
                                        <option value="">-- Select --</option>
                                        {roleData?.map((item) => (
                                            <option key={item.id} value={item.id}>
                                            {item.role_name}
                                            </option>
                                        ))}
                                        </select>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive permissonTableSize1">
                            <table className="table table-bordered align-middle text-nowrap">
                                <thead className="table-light text-center">
                                <tr>
                                    <th style={{ width: "40%" }}>Section / Module / Submodule</th>
                                    <th>Create</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {uniqueSections.map((section) => (
                                    <React.Fragment key={section}>
                                    <tr className="table-primary">
                                        <td colSpan={4}>
                                        <label className="fw-bold">
                                            <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={!!selectedSections[section]}
                                            onChange={() => handleCheckbox(setSelectedSections, section)}
                                            />
                                            {section.toUpperCase()}
                                        </label>
                                        </td>
                                    </tr>

                                    {selectedSections[section] &&
                                        permissionData
                                        .filter((mod) => mod.section === section)
                                        .map((mod) => {
                                            const hasSubModules =
                                            Array.isArray(mod.sub_module) &&
                                            mod.sub_module.length > 0 &&
                                            typeof mod.sub_module[0] === "object";

                                            return (
                                            <React.Fragment key={mod.module}>
                                                <tr className="table-secondary">
                                                    <td colSpan={4}  style={{ paddingLeft: "20px" }}>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input me-2"
                                                                checked={!!selectedModules[mod.module]}
                                                                onChange={() => handleCheckbox(setSelectedModules, mod.module)}
                                                            />
                                                        <strong>{mod.module}</strong>
                                                        </label>
                                                    </td>
                                                </tr>

                                                {selectedModules[mod.module] &&
                                                (hasSubModules ? (
                                                    mod.sub_module.map((sub) => {
                                                    const key = `${mod.module}-${sub.name}`;
                                                    const showCRUD = selectedSubModules[key] && mod.action === "Yes";

                                                    return (
                                                        <tr key={key}>
                                                        <td style={{ paddingLeft: "40px" }}>
                                                            <label>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input me-2"
                                                                checked={!!selectedSubModules[key]}
                                                                onChange={() => handleCheckbox(setSelectedSubModules, key)}
                                                            />
                                                            {sub.name}
                                                            </label>
                                                        </td>
                                                        {["create", "edit", "delete"].map((action) => (
                                                            <td key={action} className="text-center">
                                                            {showCRUD && isCrudEnabled(sub.action) && (
                                                                <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={!!crudPermissions[key]?.[action]}
                                                                onChange={() => handleCrudToggle(key, action)}
                                                                />
                                                            )}
                                                            </td>
                                                        ))}
                                                        </tr>
                                                    );
                                                    })
                                                ) : (
                                                    mod.action === "Yes" && (
                                                    <tr>
                                                        <td style={{ paddingLeft: "40px" }}>
                                                        <em>No Submodules</em>
                                                        </td>
                                                        {["create", "edit", "delete"].map((action) => (
                                                        <td key={action} className="text-center">
                                                            <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={!!crudPermissions[mod.module]?.[action]}
                                                            onChange={() => handleCrudToggle(mod.module, action)}
                                                            />
                                                        </td>
                                                        ))}
                                                    </tr>
                                                    )
                                                ))}
                                            </React.Fragment>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}
                                </tbody>
                            </table>
                            </div>

                            <div className="text-end mt-3">
                            <button className="btn btn-success" type="submit">
                                Submit
                            </button>
                            </div>
                        </div>
                    </div>

                    </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={openroledeletealert}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete this Role ? This action cannot be undone.

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleroledeleteClosealert}>No</Button>
          <Button onClick={deleteRole}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openUserdeletealert}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete this user ? This action cannot be undone.

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleuserdeleteClosealert}>No</Button>
          <Button onClick={handleDeleteClick}>Yes</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Permissions
